"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registry = void 0;
class Registry {
    constructor(name) {
        this.name = name;
    }
    getName() {
        return this.name;
    }
}
exports.Registry = Registry;
//# sourceMappingURL=registry.js.map